import { IMenuType, MenuType } from '@src/slide/domain/ui-model/constant/menu';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { INoteModel } from '@src/slide/domain/ui-model/element-modeles/Interface/note-model.interface';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { getToolbarMenuItems } from '@src/slide/application/service/menu-manager/menu-items/toolbar';
import { getPropertyMenuItems } from '@src/slide/application/service/menu-manager/menu-items/property';
import { getRightMenuItems } from '@src/slide/application/service/menu-manager/menu-items/right';
import { getQuickSettingMenuItems } from '@src/slide/application/service/menu-manager/menu-items/quick-setting';
import { IMenuItem } from '@src/slide/application/service/menu-manager/menu-items/menu-items.interface';
import * as StylePanelMenu from '@editor/src/js/constants/style-panel-data';
import * as TopMenu from '@editor/src/js/constants/top-menu-data';

/**
 * 获取禁用菜单列表
 */
export {
    getDisableMenuItems,
} from '@src/slide/application/service/menu-manager/menu-items/disable-item';

/**
 * 获取不同位置的菜单数据列表
 * @param menuType 菜单类型
 * @param model uiModel
 */
export function getMenuItems(
    menuType: IMenuType,
    model: IBaseModel | INoteModel | ISlideModel,
): IMenuItem[] {
    // 顶部菜单栏
    if (menuType === MenuType.TOP_MENU) {
        return TopMenu.getAllMenuItems();
    }
    // 顶部工具栏
    if (menuType === MenuType.TOOLBAR) {
        return getToolbarMenuItems(model);
    }
    // 右侧编辑栏
    if (menuType === MenuType.PROPERTY_BAR) {
        return getPropertyMenuItems(model);
    }
    // 右键菜单
    if (menuType === MenuType.POP_MENU) {
        return getRightMenuItems(model);
    }
    // 快捷菜单
    if (menuType === MenuType.QUICK_SETTING) {
        return getQuickSettingMenuItems(model);
    }
    // 移动端字体格式面板
    if (menuType === MenuType.STYLE_PANEL) {
        return StylePanelMenu.styleEditPanelMenuItems;
    }
    // 对齐线
    if (menuType === MenuType.GUIDES_SETTING) {
        return getRightMenuItems(model);
    }
    // 主题
    if (menuType === MenuType.THEME_SETTING) {
        return getRightMenuItems(model);
    }
    return [];
}
